import { ArticleHeading2, Button, Theme, useDeviceType } from '@cian/ui-kit';
import * as styles from './DealsBanner.css';
import cn from 'clsx';
import { useToggleState } from '@cian/react-utils';
import { DealModalForm } from '../DealModalForm';

import type { IDealsLeadFormRegionOption } from 'shared/types/dealsForm';

export interface IDealsBannerProps {
  title: string;
  formTitle: string;
  formSubtitle: string;
  regionOptions: IDealsLeadFormRegionOption[];
  postId: number;
}

export const DealsBanner: React.FC<IDealsBannerProps> = ({ title, formTitle, formSubtitle, regionOptions, postId }) => {
  const device = useDeviceType();
  const { state: modalVisible, toggle: toggleModalVisible } = useToggleState();

  return (
    <div className={cn(styles['container'], styles[device])}>
      <div className={styles['text-block']}>
        <ArticleHeading2 color="text-inverted-default">{title}</ArticleHeading2>
        <Theme theme="colored">
          <Button maxWidth={159} onClick={toggleModalVisible}>
            Оставить заявку
          </Button>
        </Theme>
      </div>
      <DealModalForm
        device={device}
        open={modalVisible}
        onOpenChange={toggleModalVisible}
        title={formTitle}
        subtitle={formSubtitle}
        regionOptions={regionOptions}
        postId={postId}
      />
    </div>
  );
};
